<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="450px"
  >
    <v-card light>
        <div style="position: absolute; right: 0px; top: 12px;">
            <v-btn class="mx-2" icon title="Close Form" @click="handleDialogClose">
                <v-icon class="material-icons-round"> close </v-icon>
            </v-btn>
        </div>
        <ValidationObserver slim v-slot="{ invalid }">
            <div class="leftpanel-container">
                <div class="register" v-if="step === 1">
                    <div class="register--container">
                        <p class="register--title mb-0">Change Phone Number</p>
                        <p class="register--subtitle">To continue enter your new mobile number.</p>
                        <div class="register__form mt-40">
                            <ValidationProvider name="Mobile No." rules="digits:10|required" v-slot="{ errors, classes }">
                                <div class="input-group mb-5" :class="classes">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">
                                            <img src = "/img/phoneNumber.svg" alt = "Phone Number">
                                        </span>
                                    </div>
                                    <input onKeyPress="if(this.value.length==10) return false;" type="number" id="mobile" class="form-control" v-model="phoneNo" maxLength="10" placeholder="9000090000">
                                </div>
                                <small class="form-group--error-message">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </div>
                            <div class="register__form--referral-bottom">
                                <div style="display: flex; justify-content: center; align-items: center">
                                    <button class="btn_new btn-secondary-new w-80 mb-15" @click="receiveOtp" :disabled="invalid">Next </button>
                                </div>
                            </div>
                    </div>
                </div>
                <div class="register" v-else-if="step === 2">
                    <div class="backButtonOne" style="position: absolute; top: 0px;" @click="clearMobileField">
                        <button class="btn-back btn w-45px mt-15 mb-15" >
                            <v-icon class="material-icons-round"> arrow_back </v-icon>
                        </button>
                    </div>
                    <div style = "position: relative; margin-top: 48px;" class="register--container">
                        <p class="register--title mb-0">Verification Code</p>
                        <p class="register--subtitle">
                            We have sent the first 3 digits of your OTP to your new phone number and the last 3 to your registered email.
                        </p>
                        <ValidationProvider name="OTP" rules="digits:6|required" v-slot="{ errors, classes }">
                            <div>
                                <div :class="classes">
                                            <v-otp-input
                                            v-model="otp"
                                            type="number"
                                            @finish="checkOtp"
                                            ></v-otp-input>
                                </div>

                            </div>
                        </ValidationProvider>
                        <div class="otp mt-15 w-100">
                            <div v-if="!otpTime" class="rightAlign">
                                <p class="otp--resend" >
                                    Did not receive OTP? <a @click="receiveOtp" class="ml-5"> Resend </a>
                                </p>
                            </div>
                            <div class="rightAlign" v-else>
                                <p class="otp--timer">
                                    You can resend the OTP in {{otpTime}} sec
                                </p>
                            </div>
                        </div>
                        <div style="display: flex; justify-content: center; align-items: center mb-15" class="register__form--referral-bottom">
                            <button class="btn_new btn-secondary-new w-80 mt-15 mb-15" @click="checkOtp" :disabled="invalid">Next </button>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
        <v-snackbar
            v-model="otpSnackbar"
            app
        >
                {{ snackbarMessage }}

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="red"
                    text
                    v-bind="attrs"
                    @click="otpSnackbar = false"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
  </v-dialog>
</template>

<script>
import lenderService from '@/services/lenderService'
export default {
    name: 'editPhoneDialog',
    components: {
    },
    props: {
        showEditPhoneDialog: Boolean
    },
    data () {
        return {
            dialog: this.showEditPhoneDialog,
            step: 1,
            isLoading: false,
            phoneNo: null,
            otpTime: 0,
            otp: '',
            otpSnackbar: false,
            snackbarMessage: ''
        }
    },
    watch: {
        otpTime: {
            handler (value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.otpTime--
                    }, 1000)
                } else {
                    this.otpTime = 0
                }
            },
            immediate: true
        }

    },
    methods: {
        handleDialogClose () {
            this.$emit('closeDialog')
        },
        receiveOtp () {
            this.$store.commit('isLoading')
            const payload = {
                newPhoneNo: this.phoneNo
            }
            lenderService.lenderPhoneUpdate(payload).then((res) => {
                this.$store.commit('isNotLoading')
                if (res.status === 200) {
                    this.otpTime = 30
                    this.step = 2
                } else if (res.status === 409) {
                    this.snackbarMessage = 'Contact number already exists! Please try some other contact number.'
                    this.otpSnackbar = true
                    this.clearMobileField()
                }
            })
        },
        checkOtp (otp) {
            this.$store.commit('isLoading')
            const payload = {
                newPhoneNo: this.phoneNo,
                otp: otp
            }
            lenderService.lenderPhoneUpdateVerify(payload).then((res) => {
                this.$store.commit('isNotLoading')
                if (res.status === 200) {
                    this.$store.dispatch('dashboard/setField', { field: 'phoneNo', value: this.phoneNo })
                    this.snackbarMessage = 'Contact information changed successfully!'
                    this.otpSnackbar = true
                    this.handleDialogClose()
                }
            })
        },
        clearMobileField () {
            this.phoneNo = null
            this.step = 1
        }
    }
}
</script>
<style lang="scss" scoped>
.v-card__title {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
  line-height: 24px;
  word-break: normal;
  display: flex;
  flex-direction: column;
  align-items: center;
}
    @import "~@/sass/components/registration-flow.scss";

    .otp-input-wrap {
        justify-content: space-around;
    }

    .rightAlign {
        text-align: right;
    }

    .otp--resend {
        color: #666e75 !important;
    }

    ::v-deep .v-input__slot {
        margin-bottom: 32px;
    }
    ::v-deep .v-otp-input {
        height: 72px;
    }
    ::placeholder {
        color: #e0e0e0
    }
    ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 45px;
        max-width: 45px;
    }
</style>
